import { useQuery } from '@tanstack/react-query';
import { config } from './config';
import { defaultCatalog, parsePublicHelpCatalog } from './public-help';

export function usePublicHelpCatalog(enabled = true) {
  const query = useQuery({
    queryKey: ['publicHelpCatalog', config.helpUrl],
    enabled,
    staleTime: 5 * 60_000,
    retry: false,
    queryFn: async ({ signal }) => {
      const response = await fetch(`${config.helpUrl}/guides.json`, { signal });
      if (!response.ok) throw new Error('Guide catalog unavailable');
      return parsePublicHelpCatalog(await response.json());
    },
  });
  return query.data ?? defaultCatalog;
}
